import React from 'react';
import { logToSentry } from '../../utils/analytics';
import { withRouter } from 'react-router-dom';
import { Div } from 'Common/components/Atoms/Div';
import GenericErrorHeaderBar from '../../components/GenericError/GenericErrorHeaderBar';
import GenericErrorBody from '../../components/GenericError/GenericErrorBody';
import withTheme from '@mui/styles/withTheme';

export class ErrorBoundaryComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };

    const { history } = this.props;

    this.unlisten = history.listen(() => {
      if (this.state.hasError) {
        this.setState({
          hasError: false,
        });
      }
    });
  }

  componentWillUnmount() {
    this.unlisten();
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    logToSentry(error.toString());
  }

  render() {
    const { theme, children } = this.props;

    if (this.state.hasError) {
      return (
        <Div height="100vh" backgroundColor={theme.palette.background.default}>
          <GenericErrorHeaderBar />
          <GenericErrorBody />
        </Div>
      );
    }

    return children;
  }
}

export const ErrorBoundary = withTheme(ErrorBoundaryComponent);

export default withRouter(ErrorBoundary);
